import { merge, clone } from 'lodash'

export const appliesMeta = (meta, routes) => {
  return routes.map((route) => {
    if (!route.meta) {
      route.meta = {}
    }

    route.meta = merge(clone(meta), route.meta)

    if (route.children) {
      route.children = appliesMeta(meta, route.children)
    }

    return route
  })
}
